import { useState } from 'react';


// Custom Hooks

export const useToggleableList = (list = [], setList ) => {

  const handleListItemClick = element => {
    let newList = [];

    const index = list.findIndex(e => e === element);
    if (index >= 0) {
      newList = [...list.slice(0, index), ...list.slice(index + 1)];
    }
    else {
      newList = [...list, element];
    }
    setList?.(newList);
  };

  const checkListItemExist = element => {
    const index = list.findIndex(e => e === element);
    return index >= 0;
  };

  const resetList = () => setList([]);

  return [ list ,handleListItemClick, checkListItemExist, resetList ];
};

export const secondToHM = (second) => {
  const minute = second / 60;
  const hour = Math.floor(minute / 60);
  return `${hour} hr ${~~(minute % 60)} m`;
}

export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}